<template>
    <div>
        <v-card>
            <!-- Desktop View -->
            <v-data-table outlined v-if="!isSmallerDisplay()" v-model="selectedItems" item-key="_id"
                :headers="headersRejected" show-select :items="rejected" class="elevation-1"
                :no-data-text="$t('message.no_data')" :footer-props="{
                    itemsPerPageText: $t('message.rows_per_page'),
                    itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                    <v-card-actions class="ml-2">
                        <v-checkbox hide-details
                            :label="$t('message.select_all') + ' (' + $t('message.members_selected', [selectedItems.length]) + ')'"
                            @change="selectAll()"></v-checkbox>
                        <v-spacer></v-spacer>
                        <v-menu elevation="0" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn outlined small elevation="0" :block="isSmallerDisplay()" color="primary"
                                    v-on="on" slot="activator" bottom>
                                    {{ $t("message.actions") }}
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item :disabled="selectedItems.length == 0">
                                    <v-list-item-title @click="openSendEmailDialog()" class="clickable">
                                        <v-icon class="mr-1">mdi-email-fast-outline</v-icon>
                                        <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                            $t("message.send_emails") }}</span>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!isSmallerDisplay()">
                                    <v-list-item-title @click="getRejectedCSV()" class="clickable">
                                        <v-icon class="mr-1">mdi-cloud-download-outline</v-icon>
                                        <span>{{ $t("message.download_list") }}</span>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-actions>
                </template>


                <template v-slot:item.avatar="{ item }">
                    <div class="d-flex align-center text-xs-center clickable" @click="goToRejected(item)">
                        <v-avatar size="36" v-if="item.userImageSmall || item.userImage">
                            <v-img :src="item.userImageSmall ? item.userImageSmall : item.userImage"></v-img>
                        </v-avatar>
                        <v-avatar size="36" color="plusIndigoLighten3" v-else>
                            <span class="font-roboto white--text text-subtitle-1">{{ getInitials(item.displayName)
                            }}</span>
                        </v-avatar>
                        <country-display class="ml-3" :country-code="item.nationality" />
                    </div>
                </template>



                <template v-slot:item.displayName="{ item }">
                    <span @click="goToRejected(item)" class="mr-1">{{ item.displayName }}</span>
                </template>

                <template v-slot:item.belt="{ item }">
                    <belt-display :belt="item.belt" :show-text="false" />
                </template>

                <template v-slot:item.removedDate="{ item }">
                    {{ item.removedDate ? $d(new Date(item.removedDate), "month_day_year", $i18n.locale) : '' }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn icon v-allowed="'approve_member'" @click="permanentlyRemove(item)">
                        <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                    <v-btn icon v-allowed="'approve_member'" @click="approveMember(item, true)">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <!-- Mobile View -->
            <v-list v-else>
                <template v-for="(m, index) in rejected">
                    <v-list-item :key="'rejected_' + m._id">
                        <v-list-item-content class="text-left">
                            <v-list-item-title>
                                <member-avatar :image="m.userImageSmall ? m.userImageSmall : m.userImage"
                                    size="25"></member-avatar>
                                <span class="ml-1">{{ m.displayName }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <belt-display :belt="m.belt" :show-text="false" size="10" />
                                <country-display :country-code="m.nationality" class="ml-2" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" fab text small slot="activator" left>
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-icon v-allowed="'approve_member'" title="Approve"
                                                @click="approveMember(m, true)">mdi-plus-circle-outline</v-icon>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-icon title="Permanently Remove" @click="permanentlyRemove(m)"
                                                v-allowed="'reject_member'">mdi-cancel</v-icon>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index + 1 < rejected.length" :key="'rejected_members_index_' + index"></v-divider>
                </template>
            </v-list>
        </v-card>
    </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import CountryDisplay from "@/components/displays/CountryFlagDisplay.vue";
import MemberAvatar from "@/components/displays/MemberAvatar.vue";
import Api from "@/services/Api";
import Api2 from "@/services/Api2";

export default {
    name: "ViewFormerMembers",
    components: {
        CountryDisplay,
        BeltDisplay,
        MemberAvatar,
    },
    props: {
        academy: Object,
        academyUser: Object,
        user: Object
    },
    data() {
        return {
            rejected: [],
            selectedItems: [],
            loading: false,
            allSelected: false,
            headersRejected: [
                {
                    text: "",
                    align: "left",
                    sortable: false,
                    value: "avatar",
                },
                { text: this.$t("message.name"), value: "displayName" },
                { text: this.$t("message.belt"), value: "belt" },
                { text: this.$t("message.removed_date"), value: "removedDate" },
                {
                    text: "",
                    align: "left",
                    sortable: false,
                    value: "actions",
                }
            ],
        };
    },
    created() {
        this.getFormerMembers();
    },
    methods: {
        async getFormerMembers() {
            this.loading = true;
            try {
                const response = await Api2().get(
                    "admins/academy/" +
                    this.$store.state.selectedAcademy +
                    "/members?get_subscriptions=true&get_curriculum_instances=true"
                );

                const data = response.data;
                if (data && data.rejected) {
                    this.rejected = data.rejected;
                }

                this.loading = false;
                this.$emit('former-members-loaded', data);
            } catch (e) {
                this.loading = false;
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            }
        },

        async approveMember(member, reapprove) {
            let data = { members: [member._id] };
            if (reapprove) data["rejected"] = true;

            try {
                const response = await Api().post(
                    "admins/academy/" + this.$store.state.selectedAcademy + "/approve",
                    data
                );

                if (response.data) {
                    // Remove from rejected list
                    const index = this.rejected.findIndex(r => r._id === member._id);
                    if (index > -1) {
                        this.rejected.splice(index, 1);
                    }

                    this.showAlert("success", this.$t("message.member_reactivated"));
                    this.$emit('member-reactivated', member);
                    this.$emit('refresh-search');
                }
            } catch (e) {
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            }
        },

        async permanentlyRemove(member) {
            if (!confirm(this.$t("message.confirm_permanent_removal"))) {
                return;
            }

            try {
                const response = await Api().delete(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/members/rejected/" + member._id
                );

                if (response) {
                    // Remove from rejected list
                    const index = this.rejected.findIndex(r => r._id === member._id);
                    if (index > -1) {
                        this.rejected.splice(index, 1);
                    }

                    this.showAlert("success", this.$t("message.member_permanently_removed"));
                    this.$emit('member-permanently-removed', member);
                }
            } catch (e) {
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            }
        },

        async getRejectedCSV() {
            try {
                const response = await Api2().get(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/export/csv/rejected"
                );

                let blob = new Blob([response.data], { type: "text/csv" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "rejected_" + new Date().toISOString() + "_" + ".csv";
                link.click();
            } catch (e) {
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            }
        },

        openSendEmailDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-send-email-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        selectAll() {
            if (!this.allSelected) {
                this.allSelected = true;
                for (let i of this.rejected)
                    this.selectedItems.push(i);
            } else {
                this.allSelected = false;
                this.selectedItems = [];
            }
        },

        goToRejected(item) {
            this.goToVisitor(item.visitorId);
        },

        goToVisitor(visitorId) {
            this.navigateTo({
                name: "viewvisitor",
                params: { visitorid: visitorId }
            });
        },

        // Utility methods
        isSmallerDisplay() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    }
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
}

.disabled-menu {
    color: gray;
}
</style>